import * as React from 'react'
import { cardVariants, type CardVariantProps } from './Card.variants'
import { cn } from '../../utils/cn'

export type CardProps = CardVariantProps &
  React.HTMLAttributes<HTMLDivElement> & {
    onPress?: () => void
  }

export default function Card({ padding, className, onPress, onClick, ...rest }: CardProps) {
  return (
    <div
      className={cn(cardVariants({ padding }), onPress ? 'cursor-pointer' : undefined, className)}
      onClick={onPress ?? onClick}
      {...rest}
    />
  )
}
